import sale from '@/api/report/sale'
import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
}

export const getters = {}

export const mutations = {
  ...baseMutations,
}

export const actions = {
  // generate daily sale item pdf
  visitation(context, data) {
    return sale.visitation(data)
  },
  visitationExcel(context, data) {
    return sale.visitationExcel(data)
  },
  getUser(context, attributes = {}) {
    return sale.user(attributes)
  },
}
